module.exports = __webpack_public_path__ + "static/media/comment-smile.7337e972.svg";